import {createReducer} from '@reduxjs/toolkit'
import {changeEventAction} from '../actions/event'
import {getPolicies, toggleAgreePolicies} from '../actions/policies'
import {sendRsvp, sendRsvpOld} from '../actions/rsvp'
import {PoliciesState} from '../types/state'

const defaultState: PoliciesState = {
  agreed: false,
  showAlert: false,
  policies: [],
}

export const policies = createReducer(defaultState, builder => {
  builder
    .addCase(changeEventAction, () => {
      return defaultState
    })
    .addCase(toggleAgreePolicies, state => {
      state.agreed = !state.agreed
    })
    .addCase(getPolicies.pending, (state, action) => {
      state.showAlert = action.meta.arg.showAlert
      state.agreed = false
    })
    .addCase(getPolicies.fulfilled, (state, action) => {
      const showAlert = action.meta.arg.showAlert

      return {
        ...state,
        ...action.payload,
        agreed: false,
        showAlert,
      }
    })
    .addCase(sendRsvp.rejected, state => {
      state.agreed = false
    })
    .addCase(sendRsvpOld.rejected, state => {
      state.agreed = false
    })
})
